import Vue from "vue";
import Router from "vue-router";
import main from "@/page/main";
import store from "@/store";
import {
  Message
} from "element-ui";

const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

let routes = [
  {
    path: "/",
    meta: {
      name: "首页",
      hidden: true
    },
    component: main,
    redirect: "/homePage",
    children: [
      {
        path: "/homePage",
        name: "homePage",
        meta: {
          name: "首页",
          rouAct: "homePage",
        },
        component: () =>
          import("@/page/HomePage/index")
      },
      {
        path: "/AIEducation",
        name: "AIEducation",
        meta: {
          name: "AI教育解决方案",
          rouAct: "AIEducation",
        },
        component: () =>
          import("@/page/AIEducation/index")
      },
      {
        path: "/FunctionalCLassroom",
        name: "FunctionalCLassroom",
        meta: {
          name: "功能教室解决方案",
          rouAct: "FunctionalCLassroom",
        },
        component: () =>
          import("@/page/FunctionalCLassroom/index"),
        children: [{
          path: '/scientificInnovation',
          name: "scientificInnovation",
          meta: {
            name: "科创功能教室",
            rouAct: "FunctionalCLassroom",
            icon: "./static/images/sl1.png"
          },
          component: () =>
            import("@/page/FunctionalCLassroom/classroom"),
        }, {
          path: '/qualityEducation',
          name: "qualityEducation",
          meta: {
            name: "素质教育功能教室",
            rouAct: "FunctionalCLassroom",
            icon: "./static/images/sl2.png"
          },
          component: () =>
            import("@/page/FunctionalCLassroom/classroom"),
        }]
      },
      {
        path: "/AfterSchoolService",
        name: "AfterSchoolService",
        meta: {
          name: "课后服务解决方案",
          rouAct: "AfterSchoolService",
        },
        component: () =>
          import("@/page/AfterSchoolService/index")
      },
      {
        path: "/NewsUpdate",
        name: "NewsUpdate",
        meta: {
          name: "新闻动态",
          rouAct: "NewsUpdate",
        },
        component: () =>
          import("@/page/NewsUpdate/index")
      },
      {
        path: "/DownloadCenter",
        name: "DownloadCenter",
        meta: {
          name: "下载中心",
          rouAct: "DownloadCenter",
        },
        component: () =>
          import("@/page/DownloadCenter/index")
      },
      {
        path: "/AboutUs",
        name: "AboutUs",
        meta: {
          name: "关于我们",
          rouAct: "AboutUs",
        },
        component: () =>
          import("@/page/AboutUs/index")
      },
      {
        path: "/LearningPlatform",
        name: "LearningPlatform",
        meta: {
          name: "学习平台",
          rouAct: "LearningPlatform",
        },
        component: {
          render (c) {
            return c("router-view");
          }
        },
        children: [{
          path: 'http://teacher.delightmom.com/index.html',
          meta: {
            name: "教师成长平台",
            rouAct: "LearningPlatform",
            icon: "./static/images/sl3.png",
            linkTo: true
          }
        }, {
          path: 'https://djpt.delightmom.com/tech/#/teaching/teachingManage',
          name: "qualityEducation",
          meta: {
            name: "素质教育学习平台",
            rouAct: "LearningPlatform",
            icon: "./static/images/sl4.png",
            linkTo: true
          }
        }, {
          path: 'https://khs.delightmom.com/school/#/login',
          name: "qualityEducation",
          meta: {
            name: "课后服务学习平台",
            rouAct: "LearningPlatform",
            icon: "./static/images/sl5.png",
            linkTo: true
          }
        }]
      },
      {
        path: "/AfterSchoolServicePlatform",
        name: "AfterSchoolServicePlatform",
        meta: {
          name: "课后服务学习平台",
          rouAct: "AfterSchoolService",
          hidden: true
        },
        component: () =>
          import("@/page/AfterSchoolService/AfterSchoolServicePlatform"),
      },
      {
        path: "/AfterSchoolCurriculumResources",
        name: "AfterSchoolCurriculumResources",
        meta: {
          name: "课后服务课程资源",
          rouAct: "AfterSchoolService",
          hidden: true
        },
        component: () =>
          import("@/page/AfterSchoolService/AfterSchoolCurriculumResources"),
      },
      {
        path: "/StandardizedTeachingService",
        name: "StandardizedTeachingService",
        meta: {
          name: "标准化的教学服务",
          rouAct: "AfterSchoolService",
          hidden: true
        },
        component: () =>
          import("@/page/AfterSchoolService/StandardizedTeachingService"),
      },
      {
        path: "/FunctionalCLassroomDetail",
        name: "FunctionalCLassroomDetail",
        meta: {
          name: "功能教室解决方案详情",
          rouAct: "FunctionalCLassroom",
          hidden: true
        },
        component: () =>
          import("@/page/FunctionalCLassroom/classRoomDetail"),
      },
      {
        path: "/dynamicDetails",
        name: "dynamicDetails",
        meta: {
          name: "新闻中心详情",
          rouAct: "NewsUpdate",
          hidden: true
        },
        component: () =>
          import("@/page/NewsUpdate/dynamicDetails"),
      }
    ]
  },
];

let page404 = {
  path: "*",
  meta: {
    isLogin: false
  },
  component: () =>
    import("@/page/404.vue")
};
routes.push(page404);
var router = new Router({
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach((to, from, next) => {
  // if (localStorage.getItem("GFMS_USER") && store.getters.isLogin) {
  //   if (to.path == "/login") {
  //     next({
  //       path: "/",
  //     });
  //   }
  // }
  next(() => {
    window.location.reload();
  });
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js